import api from './baseApi';

export type CreateOth360UserRequest = {
  subjectName: string;
  subjectEmail: string;
};

export type Oth360User = {
  id: string;
  subjectName: string;
  subjectEmail: string;
  selfLink: string;
  employeeLink: string;
  createdAt: string;
  /**
   * Optional metadata (may be added by backend without breaking older clients).
   * Used by Admin/360 table to show completion + response counts.
   */
  leaderDone?: boolean;
  selfHasSubmitted?: boolean;
  leaderHasSubmitted?: boolean;
  hasSubmitted?: boolean;
  employeeAnswersCount?: number;
  employeeResponsesCount?: number;
  answersCount?: number;
  employeesCount?: number;
};

type ApiEnvelope<T> = {
  result: T;
};

export type Pagination = {
  totalCount: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
};

export type Oth360UsersSortBy = 'subjectName' | 'subjectEmail' | 'createdAt';
export type SortDir = 'asc' | 'desc';

type PagedApiEnvelope<T> = {
  result: T;
  pagination: Pagination;
};

export async function createOth360User(
  payload: CreateOth360UserRequest
): Promise<Oth360User> {
  const { data } = await api.post<ApiEnvelope<Oth360User>>(
    'admin/oth/360/users',
    payload
  );
  return data.result;
}

export async function listOth360UsersPaged(input?: {
  page?: number;
  pageSize?: number;
  sortBy?: Oth360UsersSortBy;
  sortDir?: SortDir;
}): Promise<{ result: Oth360User[]; pagination: Pagination }> {
  const { data } = await api.get<PagedApiEnvelope<Oth360User[]>>(
    'admin/oth/360/users/paged',
    {
      params: {
        page: input?.page,
        pageSize: input?.pageSize,
        sortBy: input?.sortBy,
        sortDir: input?.sortDir,
      },
    }
  );
  return { result: data.result, pagination: data.pagination };
}

export async function deleteOth360User(id: string): Promise<{
  id: string;
  deletedAt: string;
}> {
  const { data } = await api.delete<
    ApiEnvelope<{ id: string; deletedAt: string }>
  >(`admin/oth/360/users/${encodeURIComponent(id)}`);
  return data.result;
}
